<template>
    <div class="search" id="onlySearch">
      <div key=""></div>
      <div class="top-left-search">
        <!-- 搜索框 -->
        <InputSearch ref="inputSearch" v-model="searchKey"  @onInputSearchFocus="onInputSearchFocus" @onInputSearchBlur="onInputSearchBlur" @onClearClick="onClearClick" />
      </div>
      <!-- 搜索入口 -->
      <!-- <SearchResult ref="SearchResult" :loading="loading" :pageSize="pageSize" :page="page"  :resultList="resultList" :searchKey="searchKey" :lockedSearchType="lockedSearchType" v-show="isSearchResultShow" @onPageChange="onPageChange"  /> -->
      <div class="SearchResult-box" v-show="isSearchResultShow"  >
        <!-- 筛选条件 -->
        <div class="searchCondition-box">
          <div class="searchCondition">
            <ul>
              <!-- <li class="clear-fix">
                <div class="area">
                  <div class="area-title">区域：</div>
                  <div class="area-content">
                    <el-select
                      v-model="currBusinessArea"
                      filterable
                      placeholder="请选择"
                      size="small" 
                    >
                    <el-option label="全部" value="" />
                      <el-option
                        v-for="businessArea in businessAreas"
                        :key="businessArea.label"
                        :label="businessArea.label"
                        :value="businessArea.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="lang-title">国家：</div>
                  <div class="lang-content">
                    <el-cascader
                      size="small"
                      :options="options"
                      :props="props"
                      v-model="selectedOptions"
                      @change="handleChange">
                    </el-cascader>
                  </div>
                </div>
              </li> -->
              <li class="clear-fix">
                <div class="sect">
                  <div class="sect-title">国家(地区)：</div>
                  <div class="sect-content">
                    <el-cascader
                      size="small"
                      :options="countries"
                      :props="props"
                      :show-all-levels="false"
                      collapse-tags
                      filterable
                      clearable
                      v-model="countryArray"
                      @change="handleCountryChange" style="width: 270px;">
                    </el-cascader>
                  </div>
                </div>
              </li>
              <li class="clear-fix">
                <div class="sect">
                  <div class="sect-title">语 &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  种：</div>
                  <div class="sect-content">
                    <el-cascader
                      size="small"
                      :options="languages"
                      :props="props"
                      collapse-tags
                      filterable
                      clearable
                      v-model="languageArray"
                      @change="handleLanguageChange" style="width: 270px;">
                    </el-cascader>
                    <!-- <el-select v-model="currLanguage" filterable placeholder="请选择"  size="small" style="width: 300px;" >
                      <el-option label="全部" value="" />
                      <el-option
                        v-for="language in languages"
                        :key="language.label"
                        :label="language.label"
                        :value="language.value"
                      >
                      </el-option>
                    </el-select> -->
                  </div>
                </div>
              </li>
              
              <li class="clear-fix">
                <div class="sect">
                  <div class="sect-title">产 &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  业：</div>
                  <div class="sect-content">
                    <el-cascader
                      size="small"
                      :options="professions"
                      :props="props"
                      collapse-tags
                      filterable
                      clearable
                      v-model="segmentArray"
                      @change="handleSegmentChange" style="width: 270px;">
                    </el-cascader>
                    <!-- <el-select
                      v-model="currSegment"
                      filterable
                      placeholder="请选择"
                      size="small" style="width: 300px;"
                    >
                    <el-option label="全部" value="" />
                      <el-option
                        v-for="segment in segments"
                        :key="segment.label"
                        :label="segment.label"
                        :value="segment.value"
                      >
                      </el-option>
                    </el-select> -->
                  </div>
                </div>
              </li>
              <li class="clear-fix">
                <div class="major">
                  <div class="major-title">专 &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  业：</div>
                  <div class="major-content">
                    <el-cascader
                      size="small"
                      :options="segments"
                      :props="props"
                      collapse-tags
                      filterable
                      clearable
                      v-model="professionArray"
                      @change="handleProfessionChange" style="width: 270px;">
                    </el-cascader>
                    <!-- <el-select
                      v-model="currProfession"
                      filterable
                      placeholder="请选择"
                      size="small" style="width: 300px;"
                    >
                    <el-option label="全部" value="" />
                      <el-option
                        v-for="profession in professions"
                        :key="profession.label"
                        :label="profession.label"
                        :value="profession.value"
                      >
                      </el-option>
                    </el-select> -->
                  </div>
                </div>
              </li>
              <li class="clear-fix">
                <div class="btn-bt">
                  <button
                    :class="['submit-btn', 'cursor-pointer']"
                    type="button"
                    @click="doSearch"
                  >
                    查询
                  </button>
                  <button
                    :class="['reset-btn', 'cursor-pointer']"
                    type="button"
                    @click="onResetClick"
                  >
                    重置
                  </button>
                 
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 筛选条件完 -->
    
        <!-- 结果滚动 -->
        <div class="result-show"  v-loading="lawyerLoading">
          <div class="lawyer-title">律师列表（共{{ total }}人 每页10条）</div>
          <div class="result-show-scroll lawyers">
            <ScrollDiv>
            <div v-for="lawyer in lawyers" :key="lawyer.id" :class="['lawyer-item', currLawyer.id === lawyer.id ? 'active' : '']">
              <div class="lawyer-item-left-box">
                <el-image :src="imgurl+lawyer.name+jpg" style="width: 60px; height:60px; border-radius: 50%"  >
                  <div slot="error">
                    <img
                        src="avatar/0.png"
                        style="width: 60px;"
                    />
                  </div>
                </el-image>
              </div>
              <div class="lawyer-item-top-right">
                <div class="lawyer-item-name" :title="lawyer.name">{{ lawyer.name }}</div>
                <div class="lawyer-item-lawFirms">律&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;所：{{ lawyer.lawFirms }}</div>
                <div class="lawyer-item-language">工作语言：{{ lawyer.language }}</div>
                <div class="lawyer-item-officeLocation">办公地点：{{ lawyer.officeLocation }}</div>
                <div class="lawyer-item-profession">专业领域：{{ lawyer.profession }}</div>
                <div class="lawyer-item-icon">
                  <i class="el-icon-location dingwei" title="定位" @click="doLocation(lawyer)">定位</i>
                  &nbsp;&nbsp;
                  <i class="el-icon-chat-line-square wenjian" title="详情" @click="onViewDetail(lawyer)" >详情</i>
                </div>
              </div>
            </div>
            </ScrollDiv>
          </div>
          <!-- 分页 -->
          <div class="page-mark" v-if="total !== 0">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-sizes="[1,5,10,20]"
              :page-size="pageSize"
              :pager-count="5"
              :current-page.sync="pageIndex"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            >
            </el-pagination>
          </div>
          <!-- 分页完 -->
        </div>
        <!-- 结果滚动完 -->
      </div>
      <Detail v-show="isShowDetail"  :currLawyer="currLawyer"   @closeDetailBox="closeDetailBox"></Detail>
    </div>
</template>
<script>
import InputSearch from './InputSearch'
import ScrollDiv from '@/components/ScrollDiv'
import { page } from "@/apis/extension"
import olBasicUtils from '../../scripts/olBasicUtils'
import Detail from './Detail'
import constants from '@/scripts/constants'
export default {
  name: 'Search',
  components: {  InputSearch, ScrollDiv,  Detail},
  data() {
    return {
      isInputSearchFocus: false, // 是否输入框聚焦
      isSearchResultShow: false, // 是否显示查询结果面板
      isShowDetail:false,
      // 搜索结果过滤条件
      
       // 字典
      // businessAreas: [],
      // segments: [],

      // currBusinessArea: "",
      props: { multiple: true },
      // 国家
      countries: constants.countries,
      countryArray: [],
      currCountry: '',
      // 语言
      languages: constants.languages,
      languageArray: [],
      currLanguage: '',
      // 专业
      professions: constants.professions,
      professionArray: [],
      currProfession: '',
      // 产业
      segments: constants.segments,
      segmentArray: [],
      currSegment: '',
      // 关键字
      searchKey: '',
      // 获取数据
      lawyerLoading: false,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      lawyers: [],
      currLawyer: {},
      loading: false,
      imgurl:'avatar/',
      jpg:'.jpg'
    }
  },
  watch: {
    page(val) {
      this.pageIndex = val;
    },
  },
  computed: {

},
  mounted() {
    this.$nextTick(() => {
      this.doSearch()
    })
  },
  created() {
    this.getLawyers();
  },
  methods: { 
    // 搜索框聚焦
    onInputSearchFocus() {
      this.isInputSearchFocus = true
      this.isSearchResultShow=true
      // if (this.resultList.length === 0 && !this.lockedSearchType && !this.isSearchResultShow) {
      //   this.isSearchEnterShow = true
      // }
    },
    onClearClick() {

   
      if(this.isSearchResultShow)
      {
        this.isSearchResultShow=false
      }

      if(this.isShowDetail)
      {
        this.isShowDetail=false
      }
      // if (this.resultList.length === 0 && !this.lockedSearchType && !this.isSearchResultShow) {
      //   this.isSearchEnterShow = true
      // }
    },
    // 搜索框失去焦点
    onInputSearchBlur() {
      this.isInputSearchFocus = false
      //this.isSearchResultShow=false
    },

    getLawyers() {
      this.lawyerLoading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        key: this.searchKey,
        businessArea: this.currBusinessArea,
        country: this.currCountry,
        language: this.currLanguage,
        profession: this.currProfession,
        // segment: this.currSegment,
        industry: this.currSegment,
      };
      page(params)
        .then((res) => {
          if (res && res.status === 200) {
            this.lawyers = res.data.records;
            this.total = res.data.total;
          }
          setTimeout(() => {
            this.lawyerLoading = false;
          }, 200);
        })
        .catch((err) => {
          this.lawyerLoading = false;
        });
    },

    doSearch() {
      this.pageIndex = 1;
      this.getLawyers();
    },

    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.getLawyers()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.getLawyers()
    },
 
    // 定位按钮
    doLocation(lawyer) {
      console.log(lawyer)
      if (lawyer.coordinate) {
        const lnglat = lawyer.coordinate.split(',')
        const lng = lnglat[0]
        const lat = lnglat[1]
        console.log(lnglat,'坐标')
        olBasicUtils.Position(lng,lat);
      }
    },

    // 详情查看
    onViewDetail(lawyer) {
      this.isShowDetail = true
      this.currLawyer = lawyer
    },
    // 重置按钮
    onResetClick() {
      this.currBusinessArea = ""
      this.currCountry = []
      this.currLanguage = ""
      this.currProfession = ""
      this.currSegment = []
      this.searchKey = ""
      this.doSearch()
    },
   
    // 关闭详情页
    closeDetailBox() {
      this.isShowDetail = false
    },
    handleCountryChange(val) {
      const res = []
      val.forEach((item) => {
        res.push(item[item.length - 1])
      })
      this.currCountry = res.join(',')
    },
    handleLanguageChange(val) {
      const res = []
      val.forEach((item) => {
        res.push(item[item.length - 1])
      })
      this.currLanguage = res.join(',')
    },
    handleProfessionChange(val) {
      const res = []
      val.forEach((item) => {
        res.push(item[item.length - 1])
      })
      this.currProfession = res.join(',')
    },
    handleSegmentChange(val) {
      const res = []
      val.forEach((item) => {
        res.push(item[item.length - 1])
      })
      this.currSegment = res.join(',')
    }
  }
}
</script>
<style lang="less" scoped>
.search {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  margin-top: 20px;
  margin-left: 20px;
  transition: all 0.3s;
  .top-left-search {
    width: 380px;
    height: 45px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.16);
    border-radius: 4px;
  }
}

.input-search {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 45px;
  line-height: 45px;
  vertical-align: middle;
  color:#333333;
  .input-search-title {
    display: inline-block;
    width: 90px;
    height: 100%;
    background: rgba(245, 248, 248, 1);
    border-radius: 4px 0px 0px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(128, 128, 128, 1);
    text-align: center;
    &:hover {
      color: #0097c4;
    }
  }
  input {
    width: calc(100% - 82px);
    margin-left: 15px;
    color: #333333;
    border: none;
    outline: none;
    @include placeholder;
    &.active {
      width: calc(100% - 198px);
    }
  }
  .search {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .clear {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    &:hover {
      color: #fff;
    }
  }
  .el-icon-close:before {
    color: #808d9b;
  }
}

/*查询结果面板样式*/
.SearchResult-box {
  width: 380px;
  height: calc(100vh - 75px); /*调节结果面板的整体高度*/
  margin-top: 5px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}

.result-show {
  height: calc(100% - 245px);
  position: relative;
}
.result-show-scroll {
  //滚动条的出现控制就调这个
  height: calc(100% - 93px);
}

.el-select{
  height: 34px;
}

.page-mark {
  position: absolute;
  width: 100%;
  bottom: 10px;
  text-align: center;
}

.lawyer-title {
  width: 100% ;
  height: 40px;
  line-height: 40px;
  padding-left: 15px;
  background: #eee;
  font-weight: 600;
  font-size: 14px;
}

.searchCondition-box {
  width: 380px;
  border-bottom: 1px solid #e9ecf0;
}

.searchCondition {
  height: 240px;
  padding: 16px 20px 16px 10px;
}
.clear-fix {
  height: 40px;
}
.area,
.lang,
.sect,
.major {
  height: 40px;
  line-height: 40px;
}
.area-title {
  float: left;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
}
.lang-title {
  float: left;
  height: 40px;
  line-height: 40px;
  margin-left: 20px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
}
.sect-title,
.major-title {
  float: left;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
}
.area-content {
  float: left;
  height: 34px;
  border-radius: 4px;
  width: 120px;
}
.lang-content {
  float: left;
  height: 34px;
  border-radius: 4px;
  width: 120px;
}

.sect-content .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 270px;
}

.major-content .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 270px;
}

.sect-content,
.major-content {
  float: left;
  height: 34px;
  border-radius: 4px;
  width: 270px;
}

.btn-bt {
  text-align: center;
}

.searchCondition-type .type-title,
.searchCondition-type .type-content {
  float: left;
}

.submit-btn {
  margin-right: 1%;
  width: 73px;
  height: 32px;
  margin-top: 5px;
  background: #409eff;
  color: #e9ecf0;
  border: 1px solid rgba(210, 210, 210, 1);
  border-radius: 4px;
  &.is-place {
    margin-top: 0;
  }
}
.reset-btn {
  margin-right: 1%;
  width: 63px;
  height: 32px;
  margin-top: 5px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(210, 210, 210, 1);
  border-radius: 4px;
  &.is-place {
    margin-top: 0;
  }
}
.reset-btn:hover {
  border: 1px solid #00a6d6;
  color: #00a6d6;
}


.lawyers {
  width: 100%;
  .lawyer-item {
    display: flex;
    flex-direction: row;
    width: calc(100% - 10px);
    border: dashed 1px #a8a8a8;;
    border-radius: 5px;
    margin-bottom: 5px;
    padding: 5px;
    font-size: 12px;
    cursor: pointer;
    margin-left: 5px;
    margin-top: 5px;
    &:hover {
      background: #f4f4f5;
    }
    .lawyer-item-left-box {
      width: 60px;
      display: flex;
      align-items: center;
      img {
        width: 60px;
        height: 60px;
      }
    }
    .lawyer-item-top-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-left: 15px;
      .lawyer-item-name {
        font-weight: bold;
        height: 30px;
        line-height: 30px;
        width: 290px;
        white-space: nowrap; /* 禁止换行 */
        overflow: hidden; /* 超出长度隐藏 */
        text-overflow: ellipsis; /* 显示省略号 */
        font-weight: 600;
      }
      .lawyer-item-lawFirms {
        flex: 1;
        width: calc(100%);
      }
      .lawyer-item-officeLocation {
        flex: 1;
        width: calc(100%);
      }
      .lawyer-item-profession {
        flex: 1;
        width: calc(100%);
      }
      .lawyer-item-language {
        flex: 1;
        width: calc(100%);
      }
      .lawyer-item-icon {
        width: calc(100%);
        height: 23px;
        line-height: 23px;
        text-align: right;
        padding-right: 10px;
        i {
          font-size: 14px;
          &:hover {
            color: rgb(13, 84, 131);
            font-weight: bold;
            font-size: 14px;
          }
        }
      }
    }
  }
  .active {
    background: #f5f4c1;
  }
}


</style>
